//initialise popup form
document.addEventListener("DOMContentLoaded", () => {
  const formWrapper = ".contact-form__wrapper";
  const buttons = [".button--bulk-order", ".form__close-btn"];
  const body = "body";
  new PopupForm(formWrapper, buttons.join(", "), body);
});
